<template>
  <div v-if="category?.visibleWeb === true">
    <FilterTag
      :link="translatePath(baseRouteCode, slugify(category?.id, category?.name))"
      :style-source="category"
      :on-click="handleClick"
    >
      {{ category?.name }}
    </FilterTag>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { PRODUCT_TYPE } from "@utils/constants";
import FilterTag from "@components/filter/filter-tag";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const { $eventBus } = useNuxtApp();
const route = useRoute();

const category = computed(() => props.data?.product?.category);
const routeName = computed(() => route?.name || '');

const baseRouteCode = computed(() => ({
    [PRODUCT_TYPE.OFFER]: ROUTES.CODE.OFFERS,
    [PRODUCT_TYPE.WANTED]: ROUTES.CODE.REQUESTS,
    [PRODUCT_TYPE.AUCTION]: ROUTES.CODE.AUCTIONS
})[props.data?.product?.type] || ROUTES.CODE.OFFERS);

const closeModal = () => {
  $eventBus.emit('modal:close');
}

const handleClick = async () => {
  closeModal();
  await navigatorTo({
    path: routeName.value.startsWith('classified-ads___') ||
      routeName.value.startsWith('favorites___') ||
      routeName.value.startsWith('search___') ||
      routeName.value.startsWith('offers___') ||
      routeName.value.startsWith('requests___') ||
      routeName.value.startsWith('auctions___') ? route.path : translatePath(ROUTES.CODE.ADS),
    query: route.query,
  });
  await useSearchParam('idCategory', `${category.value?.id || ''}`);
}

</script>
